module.exports = __webpack_public_path__ + "img/delAccModalUA.001e5bc1.png";